// removed by extract-text-webpack-plugin
module.exports = {"stuck":"main__stuck_24gLY","root":"main__root_2IyvL","contentWrapper":"main__contentWrapper_36rjH","hero":"main__hero_2K8E-","comics":"main__comics_OWfZK","archive":"main__archive_3ONh6","series":"main__series_146RK"};


//////////////////
// WEBPACK FOOTER
// ./src/client/containers/main/styles.less
// module id = ./src/client/containers/main/styles.less
// module chunks = comics